<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div class="smartphone">
    <div class="line-header">
      <v-system-bar dark color="primary">
        <v-icon>mdi-signal-cellular-outline</v-icon>
        <span>Line mobile</span>
        <v-spacer></v-spacer>
        <v-icon>mdi-wifi-strength-4</v-icon>
        <v-icon>mdi-battery</v-icon>
        <span>12:30</span>
      </v-system-bar>
      <v-card flat>
        <v-row class="px-2">
          <v-col cols="auto">
            <v-icon @click="fakeClick">mdi-chevron-left</v-icon>
          </v-col>
          <v-col class="text-center">
            <div>LINE画面プレビュー</div>
          </v-col>
          <v-col cols="auto">
            <v-icon @click="fakeClick">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div class="content">
      <v-container class="liff-content">
        <template v-if="step1SurveyFormat">
          <FormRendering
            :key="liffPreviewKey"
            :configJson="step1SurveyFormat"
            :isLiffMode="true"
            :userInfo="{ name: loginUser.staff_id + ' ' + loginUser.last_name + ' ' + loginUser.first_name }"
            ref="inputForm"
            :categoryRequiredFlag="true"
            :calendarLabelDisplay="false"
            :calendarButtonDisplay="true"
            :isNewAnswer="true"
          />
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
// import FormRendering from "lsc-form-rendering";
import FormRendering from "../../../FormRendering/index.vue";

export default Vue.extend({
  data() {
    return {};
  },
  components: { FormRendering },
  computed: {
    ...mapGetters(["step1SurveyFormat"]),
    ...mapState({
      liffPreviewKey: (state) => state.formEditor.previewComponentKey,
      userStore: (state) => state.auth.user,
      loginUser: (state) => state.loginUser,
    }),
  },
  methods: {
    fakeClick() {},
  },
});
</script>

<style lang="less">
/* The device with borders */
.smartphone {
  position: relative;
  width: 360px;
  height: 640px;
  margin: auto;
  border: 16px black solid;
  border-top-width: 60px;
  border-bottom-width: 60px;
  border-radius: 36px;
  background: #F5FAF5;
}

/* The horizontal line on the top of the device */
.smartphone:before {
  content: "";
  display: block;
  width: 60px;
  height: 5px;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #333;
  border-radius: 10px;
}

/* The circle on the bottom of the device */
.smartphone:after {
  content: "";
  display: block;
  width: 35px;
  height: 35px;
  position: absolute;
  left: 50%;
  bottom: -65px;
  transform: translate(-50%, -50%);
  background: #333;
  border-radius: 50%;
}

/* The screen (or content) of the device */
.smartphone .content {
  width: 100%;
  height: 450px;
  overflow-y: auto;
  background: #F5FAF5;
}

.line-header {
  background: white;
}

.liff-content {
  background-color: #F5FAF5;
}
</style>
